import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import {
  IModule,
  Items,
} from 'app/contracts/application-configurations/module';
import { environment } from 'environments/environment.prod';

declare const $: any;

export var ROUTES: IModule;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  menuItems!: any;
version:string=environment.version;

  constructor(private router: Router) {}

  async ngOnInit() {
    var akademikMi = false;

    akademikMi = JSON.parse(
      localStorage.getItem('akademikPersonelMi') || 'false'
    );

    this.menuItems = [
      {
        id: 1,
        name: 'Dashboard',
        path: 'welcome',
        icon: 'dashboard',
        class: '',
        subItems: [],
      },

      {
        id: 3,
        icon: 'menu_book',
        name: 'Ders Programı',
        path: !akademikMi ? '/ders-programi' : '/hoca-ders-programi',

        subItems: [],
      },
      {
        id: 4,
        name: 'Cihaz Yonetimi',
        path: '/cihaz-yonetimi',
        icon: 'bar_chart',
        class: '',
        subItems: [],
      },
      {
        id: 5,
        name: 'Geliştiriciye Bildir',
        path: '/geribildirim',
        icon: 'rate_review',
        class: '',
        subItems: [],
      },
    ];
  }
  logout() {
    const ogrenciNo = localStorage.getItem('ogrenciNumarasi');
    const programID = localStorage.getItem('programId');

    const storageKey = `dersler_${ogrenciNo}_${programID}`;
    const storageUpdateKey = `derslerLastUpdate_${ogrenciNo}_${programID}`;
    localStorage.removeItem(storageKey);
    localStorage.removeItem(storageUpdateKey);
    localStorage.removeItem('accessToken');
    localStorage.removeItem('hazirlikMi');

    localStorage.removeItem('programId');
    localStorage.removeItem('akademikPersonelMi');
    localStorage.removeItem('ogrenciMi');
    localStorage.removeItem('akademikMi');

    localStorage.removeItem('dersler');

    localStorage.removeItem('hocaDersler');

    localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('userList');
        localStorage.removeItem('ogrenciNumarasi')

    this.router.navigate(['login'], { queryParams: { version: environment.version } });
  }
  isMobileMenu() {
    return $(window).width() <= 991;
  }
}
